import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export const baseAuthConfig: OpenIdConfiguration = {
    triggerAuthorizationResultEvent: true,
    logLevel: environment.production ? LogLevel.None : LogLevel.Debug,
    responseType: 'code',
    clientId: 'hml',
    silentRenew: true,
    useRefreshToken: true,
    historyCleanupOff: false,
    ignoreNonceAfterRefresh: true,
    silentRenewTimeoutInSeconds: 40,
    secureRoutes: ['/dashboard', 'http://localhost:8081/dashboard']
};

export const loginPathConfig = {
    NMDPLoginConfigPath: environment.is_local ? '/HMLDashboard-login.json' : '/dashboardui/assets/HMLDashboard-login.json'
}
